import { FitmentRecord, ISearchProductsResponse, ISearchResponse } from '@api-client/src/api/types';

export const CATEGORY_TITLE_COUNT = 'count.collection_titles';

const getItems = <T>(response: ISearchResponse<T>): T | null =>
  response ? response.results : null;

const getFittingPos = (fitmentRecord: FitmentRecord): string => {
  // .split('::') becuase data is in format "engine bay::<number>"
  return fitmentRecord.fittingpositions?.split('::')[0] ?? '';
};

const getFitmentNote = (fitmentRecord: FitmentRecord): string => {
  return fitmentRecord.panote ?? '';
};

const getQtyPerVehicle = (fitmentRecord: FitmentRecord): string => {
  return fitmentRecord.qtyper ?? '';
};

// const getPipelineVariable = (response: ISearchProductsResponse, variable: string) =>
//   response.variables?.[variable];

const getPipelineVariable = (response: ISearchProductsResponse, variable: string) => '';

const getPageCount = (response: ISearchProductsResponse) => response.numberOfPages;

const getItemCount = (response: ISearchProductsResponse) => response.totalSize;

const hasNoItems = (response: ISearchProductsResponse) => response.totalSize === 0;

const hasPagination = (response: ISearchProductsResponse) => {
  const pageCount = getPageCount(response);

  return pageCount > 1;
};

const getPopularSearches = (response: ISearchProductsResponse) => response.popularSearches;

const getCategories = (response: ISearchProductsResponse) =>
  response?.aggregateFilters?.[CATEGORY_TITLE_COUNT]?.count?.counts;

const getNbHits = (response: any) => {
  if (!response.results) {
    return 0;
  }
  return response.results[0].nbHits || 0;
};

const getQueryID = (response: ISearchProductsResponse) => {
  return response?.queryID || '';
};

const getIndex = (response: ISearchProductsResponse) => {
  return response?.index || '';
};

const searchGetters = {
  getPipelineVariable,
  getItems,
  getPageCount,
  getItemCount,
  hasPagination,
  getCategories,
  hasNoItems,
  getFitmentNote,
  getFittingPos,
  getQtyPerVehicle,
  getNbHits,
  getPopularSearches,
  getQueryID,
  getIndex,
};

export default searchGetters;
